import React from 'react';
import Grid from '@mui/material/Grid';
import { ToggleSelect } from 'shared/components/abstract/interactables';
import EntityPicker from 'features/networking/ui/EntityPicker';

export const entityEnum = {
  BUILDING: 1,
  NAS: 2,
};

const searchToggleOptions = Object.entries(entityEnum)
  .map(([key, value]) => ({ name: key, value }));

/**
 * @param {Object} props
 * @param {Object<string, *>} props.entityMap - Map of entities by type
 * @param {number} props.entityType - Currently selected entity type
 * @param {Function} props.setEntityType - Function to update entity type
 */
export default function CardSelector(props) {
  const {
    entityType,
    setEntityType,
    entityMap,
  } = props;

  return (
    <Grid container size={12} spacing={2}>
      <Grid size={12}>
        <ToggleSelect
          options={searchToggleOptions}
          value={entityType}
          setValue={setEntityType}
        />
      </Grid>
      <Grid size={12}>
        <EntityPicker entity={entityMap[entityType]} />
      </Grid>
    </Grid>
  );
}
